<template>
    <NuxtLayout name="main">
        <div class="module-cantact-us">
            <section class="module-cover">
                <div class="container font-bold">
                    <div class="module-name">
                        <div class="module-name-cover">CONTACT US</div>
                        <div class="module-name-context">{{ $t("ContactUS") }}</div>
                        <div class="module-name-descript">{{ $t("ContactUs.Descript1") }}</div>
                    </div>
                    <div class="module-infos">
                        <p>{{ $t("ContactUs.Phone") }}</p>
                        <p>{{ $t("ContactUs.Email") }}</p>
                        <p>{{ $t("ContactUs.Website") }}</p>
                        <p>{{ $t("ContactUs.Address") }}</p>
                    </div>
                </div>
            </section>

            <section class="module-form container">
                <!-- * 表单名称 -->
                <div class="module-name font-variable font-bold color-1">{{ $t("ContactUs.Message") }}</div>
                <div class="module-descript">{{ $t("ContactUs.Descript2") }}</div>

                <!-- * 表单建议类型 -->
                <div class="module-content module-categorys">
                    <div class="module-name font-variable font-bold color-1">{{ $t("ContactUs.TypesAdvice") }}</div>
                    <div class="module-types">
                        <template v-for="v in types" :key="v.value">
                            <ui-button class="module-button" :class="{ active: v.value == data.type }" :width="112" @click="methods.type(v.value)">
                                {{ v.name }}
                            </ui-button>
                        </template>
                    </div>
                </div>

                <!-- * 表单内容 -->
                <div class="module-content module-form">
                    <div class="module-name font-variable font-bold color-1">{{ $t("ContactUs.DetailedInformation") }}</div>
                    <ui-form :data="data" :rules="rules" ref="form">
                        <div class="module-rowspan">
                            <ui-form-item class="module-require" prop="name" direction="column" :label="$t('FullName')">
                                <ui-input
                                    name="name"
                                    v-model="data.name"
                                    :placeholder="$t('Layout.PleaseEnterYour', { name: 'FullName' })"
                                    :width="'100%'" />
                            </ui-form-item>

                            <ui-form-item class="module-require" prop="email" direction="column" :label="$t('EmailAddress')">
                                <ui-input
                                    name="email"
                                    v-model="data.email"
                                    :placeholder="$t('Layout.PleaseEnterYour', { name: 'EmailAddress' })"
                                    :width="'100%'" />
                            </ui-form-item>

                            <ui-form-item prop="phone" direction="column" :label="$t('PhoneNumber')">
                                <ui-input
                                    name="phone"
                                    v-model="data.phone"
                                    :placeholder="$t('Layout.PleaseEnterYour', { name: 'PhoneNumber' })"
                                    :width="'100%'" />
                            </ui-form-item>
                        </div>

                        <div class="module-rowspan">
                            <ui-form-item class="module-require" prop="comment" direction="column" :label="$t('Suggestion')">
                                <ui-textarea
                                    name="comment"
                                    v-model="data.comment"
                                    :height="240"
                                    :placeholder="$t('Layout.PleaseEnterYour', { name: 'Suggestion' })" />
                            </ui-form-item>
                        </div>

                        <div class="module-submit">
                            <ui-button size="middle" :width="152" @click="methods.submit">{{ $t("BioTools.Submit") }}</ui-button>
                        </div>
                    </ui-form>
                </div>
            </section>
        </div>
    </NuxtLayout>
</template>
<script lang="ts" setup>
//* 组件库
import { UiButton, UiForm, UiFormItem, UiInput, UiTextarea } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";

//* 组合函数
const { vars, data, rules, nodes, methods } = useComposable();
const { types } = vars;
const { form } = nodes;
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
